import React, { useCallback } from 'react'

import {
  Tabs,
  ConfirmModal,
} from  '../../../components'

import Ingredients from './ingredients/index'
import Steps from './steps/index'

import actions from './variationDetailsActions'
import CopyApplianceModal from './copyApplianceModal'

const VariationDetails = ({ ingredients, defaultLocale, locales, servings, appliances, model, field, locked }) => {

  const {
    currentTab,
    tabsInfo,
    freeAppliances,
    setCurrentTab,
    handleAdd,
    handleDelete,
    currentAppliance,
    handleChangeAppliance,
    itemToDelete,
    onDelete,
    setShowDeleteModal,
    showAddApliance, setShowAddApliance,
    ingredientsSelector,
    stepsSelector,
  } = actions({ field, model, appliances, defaultLocale })

  const handleAddAppliance = useCallback(() => {
    setShowAddApliance(true)
  },[setShowAddApliance])

  return (
    <React.Fragment>
      <Tabs
        selected={currentTab}
        tabs={tabsInfo.tabs}
        onChange={setCurrentTab}
        inverted
        onAdd={!locked && freeAppliances && freeAppliances.length ? handleAddAppliance : null}
        onDelete={!locked && tabsInfo.stepsTabs && tabsInfo.stepsTabs.length > 1 ? handleDelete : null}
      >
        {
          currentTab === 'ingredients' && (
            <Ingredients {...{
              locales, ingredients, defaultLocale, servings, model, field, appliances,
              ingredientsSelector,
              locked,
            }} />
          )
        }
        {
          currentTab && currentTab.includes('steps') && (
            <Steps {...{
              defaultLocale, ingredients, locales, appliances, model, field,
              appliance: currentAppliance,
              freeAppliances,
              handleChangeAppliance,
              stepsSelector,
              locked,
            }}/>
          )
        }
      </Tabs>
      {
        !!itemToDelete && (
          <ConfirmModal
            isOpened
            onClose={() => setShowDeleteModal(null)}
            onConfirm={onDelete}
            redConfirm
          >
              Are you sure you want to delete steps for this appliance?
          </ConfirmModal>
        )
      }
      {
        showAddApliance && (
          <CopyApplianceModal
            appliances={appliances}
            usedAppliances={model.values[field].applianceSteps}
            locales={locales}
            onChange={handleAdd}
            onClose={() => setShowAddApliance(false)}
            defaultLocale={defaultLocale}
          />
        )
      }
    </React.Fragment>
  )
}

export default VariationDetails
